import { useMemo } from 'react'
import { useAiProfilePermissionUtilities } from './useAiProfilePermissionUtilities.ts'
import { type AiProfiles, useFetchAiProfiles } from './useFetchAiProfiles.ts'

type AvailableAiProfiles = {
  profiles?: AiProfiles
  pending: boolean
  success: boolean
}

export const useAvailableAiProfiles = () => {
  const { profiles, isPending: isLoadingAiConfigs, isSuccess } = useFetchAiProfiles()
  const { isLoadingPermissions, isPermissionsLoadSuccess, canView } =
    useAiProfilePermissionUtilities()

  return useMemo((): AvailableAiProfiles => {
    const success = isSuccess && isPermissionsLoadSuccess
    const pending = isLoadingAiConfigs || isLoadingPermissions

    if (pending) {
      return { pending, success }
    }

    const staticProfile = canView(profiles?.staticProfile) ? profiles?.staticProfile : undefined
    const predefinedProfile = canView(profiles?.predefinedProfile)
      ? profiles?.predefinedProfile
      : undefined
    const customProfiles = (profiles?.customProfiles ?? []).filter(canView)

    return {
      pending,
      success,
      profiles: {
        staticProfile: staticProfile,
        predefinedProfile: predefinedProfile,
        customProfiles: customProfiles,
      },
    }
  }, [
    canView,
    profiles,
    isLoadingPermissions,
    isPermissionsLoadSuccess,
    isLoadingAiConfigs,
    isSuccess,
  ])
}
